import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

import type { TopOffers } from 'shared/types/TVitrinsService';

const initialState: { topOffers: TopOffers | null } = {
  topOffers: null,
};

export const vitrinsTopOffersSlice = createSlice({
  name: 'vitrinsTopOffers',
  initialState,
  reducers: {
    setVitrinsTopOffers: (_, { payload }: PayloadAction<TopOffers>) => ({
      topOffers: payload,
    }),
  },
});

export const { setVitrinsTopOffers } = vitrinsTopOffersSlice.actions;
